import { motion } from "framer-motion";
import { formatMoney } from "@/lib/budget";

const segments = (r) => [
  { id: "bills", label: "Bills & rent", value: r.bills, color: "#2C221E" },
  { id: "savings", label: "Savings", value: r.savings, color: "#3F5E57" },
  { id: "care", label: "Period & self-care", value: r.care, color: "#E8B99A" },
  { id: "food", label: "Food & groceries", value: r.food, color: "#D6B25E" },
  { id: "activities", label: "Activities & fun", value: r.activities, color: "#6E8FA8" },
  ...r.phases.map((p) => ({ id: p.id, label: `${p.name} spending`, value: p.amount, color: p.color })),
];

export const BudgetBar = ({ result, currency }) => {
  const segs = segments(result).filter((s) => s.value > 0);
  const total = segs.reduce((s, x) => s + x.value, 0) || 1;
  return (
    <div data-testid="budget-bar">
      <div className="flex h-5 w-full overflow-hidden rounded-full bg-[#F4E6DC]">
        {segs.map((s) => (
          <motion.span key={s.id} title={s.label} className="h-full" style={{ background: s.color }}
            animate={{ width: `${(s.value / total) * 100}%` }} transition={{ type: "spring", stiffness: 120, damping: 20 }} />
        ))}
      </div>
      <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2 sm:grid-cols-3">
        {segs.map((s) => (
          <li key={s.id} className="flex items-center gap-2 text-xs text-[#5C4A42]">
            <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ background: s.color }} />
            <span className="truncate">{s.label}</span>
            <span className="ml-auto font-semibold text-[#2C221E]">{formatMoney(s.value, currency)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
